import { gql } from '@apollo/client'

export const DELETE_HRBP_RELATION = gql`
  mutation DeleteHRBPRelation($id: HashedId!) {
    deleteHRBPRelation(id: $id)
  }
`

export const CREATE_HRBP_RELATION = gql`
  mutation CreateHRBPRelation($employeeId: HashedId!, $companyIds: [HashedId!]!) {
    createHRBPRelation(employeeId: $employeeId, companyIds: $companyIds)
  }
`
